
import { IAppMessage } from "../reducers/messageReducer";

export const showNewMessage = "SHOW_NEW_MESSAGE";
export const hideMessage = "HIDE_MESSAGE";

export interface IShowNewMessage {
    type: typeof showNewMessage;
    payload: { message: IAppMessage }
}

export interface IHideMessage {
    type: typeof hideMessage;
    payload: { messageId: string }
}

export type IMessageAction
    = IShowNewMessage
    | IHideMessage
    ;


export const createShowNewMessageAction = (message: IAppMessage): IShowNewMessage => ({
    type: showNewMessage,
    payload: { message },
});

export const createHideMessageAction = (messageId: string): IHideMessage => ({
    type: hideMessage,
    payload: { messageId },
});


